import { Icon } from '@iconify/vue'
import { type StyleValue, defineComponent } from 'vue'

interface Props {
  tData?: string
  class?: unknown
  style?: StyleValue
  icon: string
  fill?: string
}

export default defineComponent((props: Props) => {
  return () => (
    <Icon
      t-data={props.tData}
      t-icon-data={import.meta.env.MODE === 'test' ? props.icon : undefined}
      icon={props.icon}
      class={props.class}
      style={props.style}
      {...{ fill: props.fill }}
    />
  )
}, {
  name: 'VIcon',
  props: ['tData', 'class', 'icon', 'fill']
})
